import { i as e, r as t } from "./cta-button.service-x51NBJyi.js";
import { defineAsyncComponent as n } from "vue";
import { getI18n as r } from "@editor/ui-utils";
//#endregion
//#region src/lang/index.ts
var i = {
	en: {
		ctaButtonApi: {
			createAlreadyExists: "The CTA button cannot be created because another CTA button with this name already exists.",
			updateAlreadyExists: "The CTA button cannot be updated because another CTA button with this name already exists.",
			created: "CTA button created",
			updated: "CTA button updated",
			notFound: "CTA button not found",
			requiredFields: "The CTA button cannot be saved because mandatory information is missing."
		},
		ctaButtonList: {
			newButton: "New CTA button",
			name: "Search for button text, link, description or ID",
			deleteCtaButton: "Delete",
			loading: "Loading CTA button",
			label: "Button text",
			link: "Button link",
			description: "Description (internal)",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			dpDelete: "Delete",
			dpDuplicate: "Duplicate",
			dpEdit: "Edit",
			dpView: "View",
			errorOnDeleting: "Error deleting",
			createCtaButton: "Create CTA button"
		},
		ctaButton: {
			selectorPlaceholder: "Select CTA button",
			label: "Button text",
			newCtaButton: "New CTA button",
			messageDeleteCtaButton: "Delete CTA button",
			messageDeleteCtaButtonTitle: "Are you sure you want to delete this CTA button? It is currently being used in articles.",
			deleteCtaButton: "Delete",
			messageDeleted: "CTA button deleted",
			errorOnDeleting: "Error deleting the CTA button",
			errorFailedLoadedCtaButtonWithId: "Error getting the CTA button",
			handledInLegacySystem: "This CTA button is being handled in {source} and cannot be edited in Vibe.",
			imageLicenseWarningBanner: "Image license not valid for selected article",
			isSticky: "Show as sticky CTA button",
			stickyButtonWarning: "Only one sticky CTA button can be added to an article.",
			contentBlockLabel: "CTA button"
		},
		ctaButtonEdit: {
			ctaButtonPrimaryType: "Primary",
			ctaButtonPrimaryTypeTooltip: "Primary color for non-commercial purposes, e.g. internal links",
			ctaButtonCommercialType: "Commercial",
			ctaButtonCommercialTypeTooltip: "Button color for commercial purposes, e.g. shop links",
			label: "Button text",
			link: "Button link",
			description: "Description (internal)",
			descriptionTooltip: "The description is only used internally, for example for internal search.",
			markAffiliate: "Mark as affiliate",
			layoutSelection: "Layout",
			buttonImageSelectorDescription: "Select or upload image (optional)",
			imageSection: "Image",
			editCtaButton: "Edit CTA button",
			messageSaved: "The changes have been saved. To display the CTA button in an article, add it to the desired article."
		}
	},
	de: {
		ctaButtonApi: {
			createAlreadyExists: "Der CTA-Button kann nicht erstellt werden, weil bereits ein CTA-Button mit diesem Namen existiert.",
			updateAlreadyExists: "Der CTA-Button kann nicht aktualisiert werden, weil schon ein CTA-Button mit diesem Namen existiert.",
			created: "CTA-Button erstellt",
			updated: "CTA-Button aktualisiert",
			notFound: "CTA-Button nicht gefunden",
			requiredFields: "Der CTA-Button kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		ctaButtonList: {
			newButton: "Neuer CTA-Button",
			name: "Suchen nach Button-Text, -Link, Beschreibung oder ID",
			deleteCtaButton: "Löschen",
			loading: "CTA-Button wird geladen",
			label: "Button-Text",
			link: "Button-Link",
			description: "Beschreibung (intern)",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (Last modified)",
			dpDelete: "Löschen",
			dpDuplicate: "Duplizieren",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			errorOnDeleting: "Fehler beim Löschen",
			createCtaButton: "CTA-Button erstellen"
		},
		ctaButton: {
			selectorPlaceholder: "CTA-Button auswählen",
			label: "Button-Text",
			newCtaButton: "Neuer CTA-Button",
			messageDeleteCtaButton: "CTA-Button löschen",
			messageDeleteCtaButtonTitle: "Willst du diesen CTA-Button wirklich löschen? Er wird derzeit in Artikeln verwendet.",
			deleteCtaButton: "Löschen",
			messageDeleted: "CTA-Button gelöscht",
			errorOnDeleting: "Fehler beim Löschen des CTA-Buttons",
			errorFailedLoadedCtaButtonWithId: "Fehler beim Abrufen des CTA-Buttons",
			handledInLegacySystem: "Dieser CTA-Button wird in {source} verwaltet und kann in Vibe nicht bearbeitet werden.",
			imageLicenseWarningBanner: "Bild-Lizenz für den ausgewählten Artikel ungültig",
			isSticky: "Als Sticky-CTA-Button anzeigen",
			stickyButtonWarning: "Einem Artikel kann höchstens ein Sticky-CTA-Button hinzugefügt werden.",
			contentBlockLabel: "CTA-Button"
		},
		ctaButtonEdit: {
			ctaButtonPrimaryType: "Standard",
			ctaButtonPrimaryTypeTooltip: "Standardfarbe für nicht-kommerzielle Zwecke, z.B. interne Verlinkungen",
			ctaButtonCommercialType: "Werblich",
			ctaButtonCommercialTypeTooltip: "Button-Farbe für werbliche Zwecke, z. B. Shop-Links",
			label: "Button-Text",
			link: "Button-Link",
			description: "Beschreibung (intern)",
			descriptionTooltip: "Die Beschreibung wird ausschließlich intern verwendet, zum Beispiel für die interne Suche.",
			markAffiliate: "Als Affiliate markieren",
			layoutSelection: "Layout",
			buttonImageSelectorDescription: "Bild auswählen oder hochladen (optional)",
			imageSection: "Bild",
			editCtaButton: "CTA-Button bearbeiten",
			messageSaved: "Die Änderungen wurden gespeichert. Um den CTA-Button in einem Artikel anzuzeigen, muss der dem gewünschten Artikel hinzugefügt werden."
		}
	}
}, a = [{
	path: "/cta-button",
	children: [
		{
			path: "",
			name: "cta_button_list",
			component: () => import("./cta-button-list.view-CMIdnlIw.js").then((e) => e.n),
			meta: { requiredRight: "cta-buttons:navigate" }
		},
		{
			path: "new",
			name: "cta_button_new",
			component: () => import("./cta-button-edit.view-C3XyKUoR.js").then((e) => e.n),
			props: () => ({
				title: r().t("ctaButton.newCtaButton"),
				backRoute: "/cta-button"
			}),
			meta: { requiredRight: ["cta-buttons:navigate"] }
		},
		{
			path: ":id",
			name: "cta_button_detail",
			component: () => import("./cta-button-edit.view-C3XyKUoR.js").then((e) => e.n),
			props: (e) => ({
				title: r().t("ctaButtonEdit.editCtaButton"),
				id: e.params.id,
				backRoute: "/cta-button"
			}),
			meta: { requiredRight: ["cta-buttons:navigate"] }
		}
	]
}], o = n(() => import("./cta-button-content-block-D2NtQdQ7.js")), s = {
	messages: i,
	routes: a,
	contentBlocks: [{
		type: "CTA_BUTTON",
		label: "ctaButton.contentBlockLabel",
		icon: "cta",
		component: o,
		defaultValue: { type: "CTA_BUTTON" }
	}]
};
//#endregion
export { o as CtaButtonContentBlock, s as ctaButtonModule, t as getCtaButton, e as getEmptyCtaButton };

//# sourceMappingURL=index.es.js.map